<template>
  <div class="newsCenter">
    <c_Nav :Index="Index" :city-code="cityCode"></c_Nav>
    <c_NewMessage></c_NewMessage>
    <!--内容  star-->
    <div class="scdMain">
      <div class="secondMainTitle">
        <i></i>
        <span>新闻中心</span>
      </div>
      <div class="scdMainText">
        <ul>
          <li v-for="item in list">
            <router-link :to="{path:'/NewsCenterDetail',query:{cityCode:cityCode,id:item.id}}">
              <div>
                <div class="title">{{item.NewsName}}</div>
                <div class="date">{{formatDate('Y-m-d',item.CreateTime)}}</div>
              </div>
              <div class="Img"><img :src="item.HomePic" alt=""></div>
            </router-link>
          </li>
        </ul>
        <c_Page :current-page="pageNo" :count-page="countPage" @listenToChildEvent="getPageNewsList"></c_Page>
      </div>
    </div>

    <!--内容  end-->

  </div>
</template>

<script>
  import c_Nav from '@/components/Nav/Nav'
  import c_NewMessage from '@/components/NewMessage/NewMessage'
  import c_Page from '@/components/Page/Page'
  export default {
    name: 'NewsCenter',
    props:['cityCode'],
    components:{c_Nav,c_NewMessage,c_Page},
    data () {
      return {
        Index:5,
        img:require("../../assets/icon_newsCenter.png"),
        list:[],
        pageNo:1,
        pageSize:10,
        countPage:0
      }
    },
    mounted() {
      this.getNewsList(this.pageNo,this.pageSize);
    },
    methods:{
      getNewsList:function (pageNo,pageSize) {
        var that = this;
        this.axios.get('NewsList',{
          params:{newsType:'1',page:pageNo,count:pageSize}
        }).then(function (res) {
          console.log(res);
          that.list = res.data.data.list;
          that.countPage = Math.ceil(res.data.data.count/that.pageSize);
        }).catch(function (err) {
          console.log(err);
        });
      },
      getPageNewsList:function (page) {
        this.pageNo = page;
        this.getNewsList(page,this.pageSize);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .clear {overflow: hidden;}
  .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

  .scdMain{width: 702px;margin: 0 auto 0;}

  /*标题  star*/
  .secondMainTitle{height: 90px;border-bottom: 2px dashed #9fb0c0;text-align: left}
  .secondMainTitle i{width: 8px;height: 36px;background: #1dd2af;display: inline-block;text-align: left;margin-top: 44px;}
  .secondMainTitle span{height:44px;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);margin: 0 0 0 14px;display:inline-block}
  /*标题  end*/

  .scdMainText{margin: 24px 0;}
  .scdMainText ul {margin-bottom: 60px}
  .scdMainText ul li{background: #f6f6f6;margin-bottom: 12px;}
  .scdMainText ul li a{display: block;padding: 8px 12px 4px 24px;box-sizing: border-box;display: flex;justify-content: space-between;align-items: center}
  .title{font-size:28px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(44,62,80,1);text-align: left;width: 500px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap}
  .date{font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(77,102,126,1);text-align: left}
  .Img{width: 32px;height: 32px;}
  .Img img{width: 100%;height: 100%}




</style>

<style>
  /*分页  star*/
  .van-pagination{height: 48px;line-height: 48px;width: 500px;margin: 0 auto}
  .van-pagination__prev{width: 112px;height: 48px;background: #eeeeee;line-height: 48px;font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color: #2c3e50}
  .van-pagination__next{width: 112px;height: 48px;background: #1dd2af;line-height: 48px;font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color: #fff}
  /*分页  end*/
</style>



// WEBPACK FOOTER //
// src/components/NewsCenter/NewsCenter.vue